
(function(){
  function listenForProduct(root,target,type,handler){
    target.addEventListener(type,handler);
    if(!root._xfunCleanups) root._xfunCleanups = [];
    root._xfunCleanups.push(function(){target.removeEventListener(type,handler);});
  }

  function cleanupProduct(root){
    if(root._xfunCleanups){
      root._xfunCleanups.splice(0).forEach(function(cleanup){cleanup();});
    }
    document.body.classList.remove('xfun-size-modal-open');
  }

  function afterHeroIdle(root,callback){
    var hero = root.querySelector('[data-xfun-gallery-slide] img');
    var idle = null;
    var timer = null;
    var scheduled = false;
    var cancelled = false;

    function detach(){
      if(!hero) return;
      hero.removeEventListener('load',schedule);
      hero.removeEventListener('error',schedule);
    }

    function run(){
      idle = null;
      timer = null;
      if(!cancelled && root.isConnected && !constrainedConnection()) callback();
    }

    function schedule(){
      if(scheduled || cancelled) return;
      scheduled = true;
      detach();
      if(!root.isConnected || constrainedConnection()) return;
      if(typeof window.requestIdleCallback === 'function') idle = window.requestIdleCallback(run,{timeout:2000});
      else timer = window.setTimeout(run,200);
    }

    if(!root._xfunCleanups) root._xfunCleanups = [];
    root._xfunCleanups.push(function(){
      cancelled = true;
      detach();
      if(idle !== null && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(idle);
      if(timer !== null) window.clearTimeout(timer);
    });
    if(hero && !hero.complete){
      hero.addEventListener('load',schedule);
      hero.addEventListener('error',schedule);
      if(hero.complete) schedule();
    }else schedule();
  }

  function moneyFormatter(root){
    var currency = root.getAttribute('data-currency') || 'EUR';
    var localeAttr = root.getAttribute('data-locale') || 'fr';
    var locale = localeAttr.toLowerCase().indexOf('fr') === 0 ? 'fr-FR' : localeAttr;
    return function(cents){
      var value = Number(cents || 0) / 100;
      try{
        return new Intl.NumberFormat(locale,{
          style:'currency',
          currency:currency,
          minimumFractionDigits:0,
          maximumFractionDigits:2
        }).format(value);
      }catch(e){
        return value.toFixed(0) + ' ' + currency;
      }
    };
  }

  function initGallery(root){
    var viewport = root.querySelector('[data-xfun-gallery-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-xfun-gallery-slide]'));
    var prev = root.querySelector('[data-xfun-gallery-prev]');
    var next = root.querySelector('[data-xfun-gallery-next]');
    var indexNode = root.querySelector('[data-xfun-gallery-index]');
    var secretDots = Array.prototype.slice.call(root.querySelectorAll('[data-xfun-gallery-secret-dot]'));
    if(!viewport || slides.length < 2) return;

    var current = 0;
    var target = null;
    var frame = null;
    var settleTimer = null;

    function syncGalleryButtons(){
      if(prev)prev.classList.toggle('is-disabled',current<=0);
      if(next)next.classList.toggle('is-disabled',current>=slides.length-1);
    }

    function render(){
      if(indexNode) indexNode.textContent = String(current + 1);
      secretDots.forEach(function(dot,i){dot.classList.toggle('is-active',i===current);});
      syncGalleryButtons();
    }

    function slideLeft(index){
      return slides[index].getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
    }

    function go(index,behavior){
      current = Math.max(0,Math.min(slides.length - 1,index));
      target = behavior === 'auto' ? null : current;
      slides[current].querySelectorAll('img').forEach(function(image){
        image.loading = 'eager';
        image.fetchPriority = 'high';
        image.decoding = 'async';
      });
      window.clearTimeout(settleTimer);
      viewport.scrollTo({left:slideLeft(current),behavior:behavior || 'smooth'});
      render();
      settleTimer = window.setTimeout(settle,320);
      queueSync();
    }

    function sync(){
      var width = viewport.clientWidth || 1;
      if(target !== null){
        if(Math.abs(viewport.scrollLeft - slideLeft(target)) > 2) return;
        target = null;
      }
      current = Math.max(0,Math.min(slides.length - 1,Math.round(viewport.scrollLeft / width)));
      render();
    }

    function queueSync(){
      if(frame !== null) return;
      frame = window.requestAnimationFrame(function(){frame = null;sync();});
    }

    function settle(event){
      if(event && target !== null && Math.abs(viewport.scrollLeft - slideLeft(target)) > 2) return;
      window.clearTimeout(settleTimer);
      settleTimer = null;
      target = null;
      sync();
    }

    function scrolled(){
      queueSync();
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle,160);
    }

    function userScroll(){
      target = null;
      window.clearTimeout(settleTimer);
      queueSync();
    }

    if(prev) prev.addEventListener('click',function(){go(current - 1);});
    if(next) next.addEventListener('click',function(){go(current + 1);});
    viewport.addEventListener('scroll',scrolled,{passive:true});
    viewport.addEventListener('scrollend',settle);
    viewport.addEventListener('wheel',userScroll,{passive:true});
    viewport.addEventListener('pointerdown',userScroll,{passive:true});
    viewport.addEventListener('touchstart',userScroll,{passive:true});
    root._xfunGalleryGo = go;
    if(!root._xfunCleanups) root._xfunCleanups = [];
    root._xfunCleanups.push(function(){
      if(frame !== null) window.cancelAnimationFrame(frame);
      window.clearTimeout(settleTimer);
      viewport.removeEventListener('scroll',scrolled);
      viewport.removeEventListener('scrollend',settle);
      viewport.removeEventListener('wheel',userScroll);
      viewport.removeEventListener('pointerdown',userScroll);
      viewport.removeEventListener('touchstart',userScroll);
      delete root._xfunGalleryGo;
    });

    syncGalleryButtons();
  }

  function initSizeModal(root){
    var modal = root.querySelector('[data-xfun-size-modal]');
    if(!modal) return;

    var opens = Array.prototype.slice.call(root.querySelectorAll('[data-xfun-open-size]'));
    var closes = Array.prototype.slice.call(modal.querySelectorAll('[data-xfun-close-size]'));
    var fitLocale = root.getAttribute('data-locale') || 'fr';
    var panel = modal.querySelector('[role="dialog"]');
    var lastOpener = null;

    function open(event){
      lastOpener = event && event.currentTarget ? event.currentTarget : null;
      modal.hidden = false;
      modal.setAttribute('aria-hidden','false');
      if(lastOpener) lastOpener.setAttribute('aria-expanded','true');
      document.body.classList.add('xfun-size-modal-open');
      if(panel) panel.scrollTop = 0;
      var closeButton = modal.querySelector('.xfun-size-modal__close');
      if(closeButton) closeButton.focus({preventScroll:true});
    }

    function close(){
      modal.hidden = true;
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('xfun-size-modal-open');
      opens.forEach(function(button){button.setAttribute('aria-expanded','false');});
      if(lastOpener && document.contains(lastOpener)) lastOpener.focus({preventScroll:true});
    }

    opens.forEach(function(button){
      button.setAttribute('aria-haspopup','dialog');
      button.setAttribute('aria-controls',modal.id);
      button.setAttribute('aria-expanded','false');
      button.addEventListener('click',open);
    });
    closes.forEach(function(button){button.addEventListener('click',close);});

    var unitButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-xfun-unit]'));
    if(root.getAttribute('data-xfun-size-policy') === 'clothing-five'){
      var publicSizes = ['S','M','L','XL','XXL'];
      modal.querySelectorAll('.xfun-size-modal__table table tr').forEach(function(row){
        var label = row.cells[0];
        if(!label) return;
        var sourceSize = label.textContent.trim().toUpperCase().replace(/\s+/g,'');
        if(!/^(?:[2-9]?XS|X{2,6}S|S|M|L|XL|[2-9]XL|X{2,6}L)$/.test(sourceSize)) return;
        var publicSize = sourceSize === '2XL' ? 'XXL' : sourceSize;
        if(publicSizes.indexOf(publicSize) === -1){
          row.remove();
        }else{
          label.textContent = publicSize;
        }
      });
    }
    var sizeTable = modal.querySelector('.xfun-size-modal__table table');
    if(sizeTable){
      sizeTable.querySelectorAll('td,th').forEach(function(cell){
        cell.dataset.xfunCmText = cell.textContent;
      });
    }
    function formatMeasurement(value, digits){
      return new Intl.NumberFormat(fitLocale,{maximumFractionDigits:digits}).format(Number(value.replace(',','.')));
    }
    function convertTable(unit){
      if(!sizeTable) return;
      sizeTable.querySelectorAll('td,th').forEach(function(cell){
        var original = cell.dataset.xfunCmText || cell.textContent;
        if(cell.cellIndex === 0 || cell.getAttribute('scope') === 'row'){
          cell.textContent = original;
          return;
        }
        if(cell.closest('thead') || cell.parentElement === sizeTable.rows[0]){
          cell.textContent = original.replace(/\bcm\s*\/\s*in\b/gi,unit).replace(/\bcm\b/gi,unit);
          return;
        }
        var unitPattern = new RegExp('(\\d+(?:[.,]\\d+)?(?:\\s*[–—-]\\s*\\d+(?:[.,]\\d+)?)?)\\s*' + unit + '\\b','i');
        var existingValue = original.match(unitPattern);
        if(existingValue){
          cell.textContent = existingValue[1].replace(/\d+(?:[.,]\d+)?/g,function(num){
            return formatMeasurement(num,2);
          }) + ' ' + unit;
          return;
        }
        if(unit === 'cm'){
          cell.textContent = original;
          return;
        }
        cell.textContent = original.replace(/\d+(?:[.,]\d+)?/g,function(num){
          var value = Number(num.replace(',','.'));
          return new Intl.NumberFormat(fitLocale,{maximumFractionDigits:1}).format(value / 2.54);
        }).replace(/\bcm\b/gi,'in');
      });
    }
    convertTable('cm');
    unitButtons.forEach(function(button){
      button.addEventListener('click',function(){
        var unit = button.getAttribute('data-xfun-unit') || 'cm';
        unitButtons.forEach(function(other){
          var active=other===button;
          other.classList.toggle('is-active',active);
          other.setAttribute('aria-pressed',active?'true':'false');
        });
        convertTable(unit);
      });
    });

    modal.addEventListener('keydown',function(event){
      if(modal.hidden || event.key !== 'Tab' || !panel) return;
      var focusable = Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function(node){
        return !node.hidden && node.getClientRects().length > 0;
      });
      if(!focusable.length){
        event.preventDefault();
        panel.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if(event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))){
        event.preventDefault();
        last.focus();
      }else if(!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))){
        event.preventDefault();
        first.focus();
      }
    });
    listenForProduct(root,document,'keydown',function(event){
      if(event.key === 'Escape' && !modal.hidden){
        event.preventDefault();
        close();
      }
    });
  }

  function initVariants(root){
    var variantsNode = root.querySelector('[data-xfun-variants]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-xfun-option]'));
    groups.sort(function(a,b){
      return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index'));
    });
    var form = root.querySelector('.xfun-luxe-buyform');
    var variantInput = root.querySelector('[data-xfun-variant-input]');
    var nativeVariant = root.querySelector('[data-xfun-native-variant]');
    var nativeVariantSelect = root.querySelector('[data-xfun-native-variant-select]');
    var addButton = root.querySelector('[data-xfun-add]');
    var addLabel = root.querySelector('[data-xfun-add-label]');
    var priceNode = root.querySelector('[data-xfun-price]');
    var stickyButton = root.querySelector('[data-xfun-sticky-add]');
    var stickyLabel = root.querySelector('[data-xfun-sticky-label]');
    var stickyPrice = root.querySelector('[data-xfun-sticky-price]');
    if(!variantsNode || !form || !variantInput || !addButton) return;

    var variants = [];
    try{
      variants = JSON.parse(variantsNode.textContent || '[]');
    }catch(e){
      variants = [];
    }
    if(!Array.isArray(variants) || !variants.length) return;

    var currentId = root.getAttribute('data-current-variant');
    var selectedId = nativeVariantSelect && nativeVariantSelect.value || root.getAttribute('data-selected-variant');
    var selectedVariant = variants.find(function(v){return String(v.id) === String(selectedId);}) || null;
    var currentVariant = selectedVariant || variants.find(function(v){return String(v.id) === String(currentId);}) || variants[0] || null;
    var selected = new Array(groups.length).fill(null);
    var formatMoney = moneyFormatter(root);
    var pending = false;
    var pendingOptionStates = [];
    var nativeSubmission = false;
    var addedLabelTimer = null;
    var cartSyncVersion = 0;
    var activeController = null;
    var feedback = root.querySelector('[data-xfun-cart-feedback]');
    var feedbackMessage = root.querySelector('[data-xfun-cart-message]');
    var feedbackClose = root.querySelector('[data-xfun-cart-feedback-close]');
    var feedbackOpener = null;

    var labelSelectSize = root.getAttribute('data-label-select-size') || 'SELECT A SIZE';
    var labelSelectOptions = root.getAttribute('data-label-select-options') || 'SELECT OPTIONS';
    var labelAdd = root.getAttribute('data-label-add') || 'ADD TO BAG';
    var labelAdding = root.getAttribute('data-label-adding') || 'Adding to your bag';
    var labelSold = root.getAttribute('data-label-soldout') || 'SOLD OUT';
    var labelAdded = root.getAttribute('data-label-added') || 'Added to your bag';
    var labelAddError = root.getAttribute('data-label-add-error') || 'This item could not be added. Please try again.';
    var labelAddUncertain = root.getAttribute('data-label-add-uncertain') || 'We could not confirm the addition. Please check your bag before trying again.';

    function closeFeedback(){
      if(!feedback) return;
      var restoreFocus = document.activeElement === feedbackClose;
      feedback.hidden = true;
      if(restoreFocus && feedbackOpener && feedbackOpener.isConnected){
        feedbackOpener.focus({preventScroll:true});
      }
    }

    function showFeedback(message,state){
      if(!feedback || !feedbackMessage || !root.isConnected) return;
      feedback.dataset.state = state;
      feedback.hidden = false;
      feedbackMessage.textContent = message;
    }

    if(feedbackClose) feedbackClose.addEventListener('click',closeFeedback);
    listenForProduct(root,document,'keydown',function(event){
      if(event.key === 'Escape' && feedback && !feedback.hidden){
        closeFeedback();
      }
    });

    function cartRoot(){
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    }

    function sectionRequestIds(){
      if(typeof getCartSectionRequestIds === 'function'){
        var ids = getCartSectionRequestIds();
        if(Array.isArray(ids) && ids.length) return ids;
      }
      return ['cart-items','cart-footer','cart-item-count','cart-live-region'];
    }

    function completeSections(data,ids){
      return data.sections && ids.every(function(id){
        return typeof data.sections[id] === 'string' && data.sections[id].trim() !== '';
      });
    }

    function announceCart(data,version){
      if(version !== cartSyncVersion) return;
      document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem',{
        bubbles:true,
        detail:{response:data,sourceId:form.id}
      }));
    }

    function refreshCount(version){
      return fetch(cartRoot() + 'cart.js',{
        credentials:'same-origin',headers:{Accept:'application/json'}
      }).then(function(response){
        if(!response.ok) throw new Error('cart');
        return response.json();
      }).then(function(cart){
        if(version !== cartSyncVersion || typeof cart.item_count !== 'number') return;
        document.querySelectorAll('[data-xfun-cart-count]').forEach(function(badge){
          badge.textContent = String(cart.item_count);
          badge.hidden = cart.item_count === 0;
        });
        if(window.theme) window.theme.cartItemCount = cart.item_count;
      }).catch(function(){});
    }

    function reconcileCart(data,ids,version){
      if(completeSections(data,ids)){
        announceCart(data,version);
        return;
      }
      var missing = ids.filter(function(id){
        return !data.sections || typeof data.sections[id] !== 'string' || !data.sections[id].trim();
      });
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(missing.join(',')),{
        credentials:'same-origin',headers:{Accept:'application/json'}
      }).then(function(response){
        if(!response.ok) throw new Error('sections');
        return response.json();
      }).then(function(sections){
        if(version !== cartSyncVersion) return;
        data.sections = Object.assign({},data.sections || {},sections);
        if(completeSections(data,ids)) announceCart(data,version);
        else refreshCount(version);
      }).catch(function(){refreshCount(version);});
    }

    groups.forEach(function(group){
      var index = Number(group.getAttribute('data-option-index'));
      var isSize = group.hasAttribute('data-size-option');

      if((!isSize || selectedVariant) && currentVariant && currentVariant.options && currentVariant.options[index] != null){
        selected[index] = String(currentVariant.options[index]);
        var currentButton = Array.prototype.slice.call(group.querySelectorAll('[data-xfun-option-value]')).find(function(button){
          return button.getAttribute('data-value') === selected[index];
        });
        if(currentButton){
          currentButton.classList.add('is-selected');
          currentButton.setAttribute('aria-pressed','true');
        }
      }

      group.querySelectorAll('[data-xfun-option-value]').forEach(function(button){
        button.addEventListener('click',function(){
          if(pending || button.disabled) return;
          group.querySelectorAll('[data-xfun-option-value]').forEach(function(other){
            other.classList.remove('is-selected');
            other.setAttribute('aria-pressed','false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed','true');
          selected[index] = button.getAttribute('data-value');
          update();
        });
      });

      var sizeSelect = group.querySelector('[data-xfun-size-select]');
      if(sizeSelect){
        sizeSelect.value = selected[index] || '';
        sizeSelect.addEventListener('change',function(){
          if(pending){
            sizeSelect.value = selected[index] || '';
            return;
          }
          selected[index] = sizeSelect.value || null;
          update();
        });
      }
    });

    var mediaMapNode = root.querySelector('[data-xfun-variant-media]');
    var variantMedia = {};
    var lastMediaOptions = null;
    try{
      variantMedia = JSON.parse(mediaMapNode && mediaMapNode.textContent || '{}');
    }catch(e){
      variantMedia = {};
    }

    function wakeNativeMedia(slide,priority){
      if(!slide) return;
      slide.querySelectorAll('img').forEach(function(image){
        image.loading = 'eager';
        image.fetchPriority = priority || 'low';
        image.decoding = 'async';
      });
    }

    function nativeMediaForChoice(optionIndex,value){
      var visualOptions = groups.map(function(group,index){
        return group.hasAttribute('data-size-option') ? null : index;
      }).filter(function(index){return index !== null;});
      var candidate = variants.find(function(variant){
        return variantMedia[String(variant.id)] && visualOptions.every(function(index){
          var wanted = index === optionIndex ? value : selected[index];
          return wanted != null && String(variant.options[index]) === String(wanted);
        });
      });
      if(!candidate) return null;
      var mediaId = String(variantMedia[String(candidate.id)]);
      return Array.prototype.slice.call(root.querySelectorAll('[data-xfun-gallery-slide]')).find(function(slide){
        return slide.getAttribute('data-media-id') === mediaId;
      });
    }

    groups.forEach(function(group,index){
      if(group.hasAttribute('data-size-option')) return;
      group.querySelectorAll('[data-xfun-option-value]').forEach(function(button){
        function intent(){
          if(constrainedConnection()) return;
          wakeNativeMedia(nativeMediaForChoice(index,button.getAttribute('data-value')),'low');
        }
        button.addEventListener('pointerenter',intent,{passive:true});
        button.addEventListener('focus',intent);
        button.addEventListener('touchstart',intent,{passive:true});
      });
    });

    afterHeroIdle(root,function(){
      if(!root.isConnected || constrainedConnection()) return;
      for(var index = 0;index < groups.length;index++){
        var group = groups[index];
        if(group.hasAttribute('data-size-option')) continue;
        var alternative = Array.prototype.slice.call(group.querySelectorAll('[data-xfun-option-value]:not(:disabled)')).find(function(button){
          return button.getAttribute('data-value') !== selected[index];
        });
        if(alternative){
          wakeNativeMedia(nativeMediaForChoice(index,alternative.getAttribute('data-value')),'low');
          break;
        }
      }
    });

    function syncVariantMedia(){
      var visualOptions = groups.map(function(group,index){
        return group.hasAttribute('data-size-option') ? null : index;
      }).filter(function(index){return index !== null;});
      if(!visualOptions.length || visualOptions.some(function(index){return selected[index] == null;})) return;
      var optionKey = JSON.stringify(visualOptions.map(function(index){return selected[index];}));
      if(optionKey === lastMediaOptions) return;
      var candidate = variants.find(function(variant){
        return variantMedia[String(variant.id)] && visualOptions.every(function(index){
          return String(variant.options[index]) === String(selected[index]);
        });
      });
      if(!candidate) return;
      var viewport = root.querySelector('[data-xfun-gallery-viewport]');
      if(!viewport) return;
      var mediaId = String(variantMedia[String(candidate.id)]);
      var slide = Array.prototype.slice.call(viewport.querySelectorAll('[data-xfun-gallery-slide]')).find(function(item){
        return item.getAttribute('data-media-id') === mediaId;
      });
      if(!slide) return;
      wakeNativeMedia(slide,'high');
      lastMediaOptions = optionKey;
      if(root._xfunGalleryGo){
        root._xfunGalleryGo(Array.prototype.indexOf.call(viewport.querySelectorAll('[data-xfun-gallery-slide]'),slide),'auto');
        return;
      }
      var left = slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
      viewport.scrollTo({left:left,behavior:'auto'});
      viewport.dispatchEvent(new Event('scroll'));
    }

    function syncNativeColorLabel(){
      root.querySelectorAll('[data-xfun-native-color-label]').forEach(function(label){
        var index = Number(label.getAttribute('data-option-index'));
        if(!Number.isInteger(index) || index < 0 || index >= selected.length || selected[index] == null) return;
        label.textContent = String(selected[index]);
      });
    }

    function incomplete(){
      return selected.some(function(value){return value == null;});
    }

    function matchingVariant(){
      if(groups.length === 0) return currentVariant;
      if(incomplete()) return null;
      return variants.find(function(variant){
        if(!variant.options || variant.options.length !== selected.length) return false;
        return variant.options.every(function(value,index){
          return String(value) === String(selected[index]);
        });
      }) || null;
    }

    function focusMissing(){
      var missingIndex = selected.findIndex(function(value){return value == null;});
      var group = groups[missingIndex] || groups.find(function(item){return item.hasAttribute('data-size-option');});
      if(!group) return;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      group.scrollIntoView({behavior:reducedMotion ? 'auto' : 'smooth',block:'center'});
      var control = group.querySelector('[data-xfun-size-select]') || group.querySelector('[data-xfun-option-value]:not(:disabled)');
      if(control) control.focus({preventScroll:true});
      group.classList.add('is-attention');
      window.setTimeout(function(){group.classList.remove('is-attention');},650);
    }

    function setLabel(text){
      if(addLabel) addLabel.textContent = text;
      if(stickyLabel) stickyLabel.textContent = text;
    }

    function setPurchaseDisabled(value){
      [addButton,stickyButton].forEach(function(button){
        if(!button) return;
        var disabled = value || root.dataset.xfunCartPending === 'true' || root.dataset.xfunColorLoading === 'true';
        button.disabled = disabled;
        button.setAttribute('aria-disabled',String(disabled));
      });
    }

    function setPending(value){
      pending = value;
      root.dataset.xfunCartPending = String(value);
      if(value){
        pendingOptionStates = Array.prototype.map.call(root.querySelectorAll('[data-xfun-option-value], [data-xfun-size-select]'),function(control){
          var state = {control:control,disabled:control.disabled};
          control.disabled = true;
          return state;
        });
      }else{
        pendingOptionStates.forEach(function(state){state.control.disabled = state.disabled;});
        pendingOptionStates = [];
      }
      setPurchaseDisabled(value);
      [addButton,stickyButton].forEach(function(button){
        if(!button) return;
        if(value) button.setAttribute('aria-busy','true');
        else button.removeAttribute('aria-busy');
      });
      if(value){
        form.setAttribute('aria-busy','true');
        setLabel(labelAdding);
      }else{
        form.removeAttribute('aria-busy');
      }
      root.dispatchEvent(new CustomEvent('xfun:product:pending',{bubbles:true,detail:{pending:value}}));
    }

    function update(){
      if(pending) return;
      window.clearTimeout(addedLabelTimer);
      var variant = matchingVariant();
      syncVariantMedia();
      syncNativeColorLabel();
      var noStock = !variants.some(function(item){return item.available;});
      setPurchaseDisabled(noStock || (!incomplete() && (!variant || !variant.available)));

      if(incomplete()){
        variantInput.value = '';
        var hasSize = groups.some(function(group){return group.hasAttribute('data-size-option');});
        setLabel(noStock ? labelSold : hasSize ? labelSelectSize : labelSelectOptions);
        addButton.classList.toggle('is-soldout',noStock);
        if(stickyButton) stickyButton.classList.toggle('is-soldout',noStock);
        return;
      }

      if(!variant){
        variantInput.value = '';
        setLabel(labelSold);
        addButton.classList.add('is-soldout');
        if(stickyButton) stickyButton.classList.add('is-soldout');
        return;
      }

      variantInput.value = variant.id;

      var formatted = formatMoney(variant.price);
      if(priceNode) priceNode.textContent = formatted;
      if(stickyPrice) stickyPrice.textContent = formatted;

      if(variant.available){
        setLabel(labelAdd);
        addButton.classList.remove('is-soldout');
        if(stickyButton) stickyButton.classList.remove('is-soldout');
      }else{
        setLabel(labelSold);
        addButton.classList.add('is-soldout');
        if(stickyButton) stickyButton.classList.add('is-soldout');
      }
    }

    form.addEventListener('submit',async function(event){
      if(pending || root.dataset.xfunCartPending === 'true' || root.dataset.xfunColorLoading === 'true'){
        event.preventDefault();
        return;
      }
      var variant = matchingVariant();
      if(!variant || !variant.available){
        event.preventDefault();
        if(incomplete()) focusMissing();
        return;
      }
      if(typeof window.fetch !== 'function' || typeof window.FormData !== 'function'){
        nativeSubmission = true;
        setPending(true);
        return;
      }
      event.preventDefault();
      window.clearTimeout(addedLabelTimer);
      feedbackOpener = document.activeElement === stickyButton ? stickyButton : addButton;
      closeFeedback();
      setPending(true);
      var version = ++cartSyncVersion;
      var succeeded = false;
      var timeout = null;
      var controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      activeController = controller;
      try{
        var body = new FormData(form);
        body.delete('return_to');
        var ids = sectionRequestIds();
        body.set('sections',ids.join(','));
        body.set('sections_url',window.location.pathname);
        if(controller) timeout = window.setTimeout(function(){controller.abort();},20000);
        var response = await fetch(cartRoot() + 'cart/add.js',{
          method:'POST',credentials:'same-origin',
          headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
          body:body,signal:controller ? controller.signal : undefined
        });
        var data;
        try{
          data = await response.json();
        }catch(parseError){
          if(!response.ok) parseError = new Error(labelAddError);
          parseError.confirmedFailure = !response.ok;
          throw parseError;
        }
        if(!response.ok || data.status){
          var error = new Error(typeof data.description === 'string' ? data.description : labelAddError);
          error.confirmedFailure = true;
          throw error;
        }
        succeeded = true;
        showFeedback(labelAdded,'success');
        reconcileCart(data,ids,version);
      }catch(error){
        showFeedback(error.confirmedFailure ? error.message || labelAddError : labelAddUncertain,'error');
        refreshCount(version);
      }finally{
        window.clearTimeout(timeout);
        if(activeController === controller) activeController = null;
        setPending(false);
        update();
        if(succeeded){
          setLabel(labelAdded);
          addedLabelTimer = window.setTimeout(update,2000);
        }
      }
    });

    listenForProduct(root,document,'shopify:section:unload',function(event){
      if(event.target && event.target.contains(root)){
        cleanupProduct(root);
      }
    });

    listenForProduct(root,window,'pageshow',function(event){
      if(!event.persisted || !root.isConnected || !pending || !nativeSubmission) return;
      nativeSubmission = false;
      setPending(false);
      update();
    });

    if(!root._xfunCleanups) root._xfunCleanups = [];
    root._xfunCleanups.push(function(){
      if(activeController) activeController.abort();
      window.clearTimeout(addedLabelTimer);
      cartSyncVersion++;
    });
    root._xfunRefreshPurchase = update;

    if(stickyButton){
      stickyButton.addEventListener('click',function(){
        if(pending || root.dataset.xfunCartPending === 'true' || root.dataset.xfunColorLoading === 'true') return;
        var variant = matchingVariant();
        if(!variant || !variant.available){
          if(incomplete()) focusMissing();
          return;
        }
        if(form.requestSubmit){
          form.requestSubmit(addButton);
        }else{
          addButton.click();
        }
      });
    }

    if(groups.length === 0 && currentVariant){
      selected = [];
      variantInput.value = currentVariant.id;
      var initial = formatMoney(currentVariant.price);
      if(priceNode) priceNode.textContent = initial;
      if(stickyPrice) stickyPrice.textContent = initial;
      setLabel(currentVariant.available ? labelAdd : labelSold);
      setPurchaseDisabled(!currentVariant.available);
      if(!currentVariant.available){
        addButton.classList.add('is-soldout');
        if(stickyButton) stickyButton.classList.add('is-soldout');
      }
    }else{
      update();
    }
    variantInput.disabled = false;
    if(nativeVariantSelect) nativeVariantSelect.disabled = true;
    if(nativeVariant) nativeVariant.hidden = true;
    root.querySelectorAll('[data-xfun-enhanced-only]:not([data-xfun-sticky])').forEach(function(node){node.hidden = false;});
  }

  function initSticky(root){
    var sticky = root.querySelector('[data-xfun-sticky]');
    var addButton = root.querySelector('[data-xfun-add]');
    if(!sticky || !addButton) return;
    sticky.hidden = true;
    var header = document.querySelector('[data-xfun-header]');
    var viewport = window.visualViewport;
    var frame = null;
    var active = true;

    function sync(){
      if(!active || !root.isConnected) return;
      var top = viewport ? viewport.offsetTop : 0;
      var bottom = top + (viewport ? viewport.height : window.innerHeight);
      if(header){
        var headerRect = header.getBoundingClientRect();
        if(headerRect.bottom > top && headerRect.top < bottom){
          top = Math.max(top,headerRect.bottom);
        }
      }
      if(!sticky.hidden && sticky.getClientRects().length){
        var stickyRect = sticky.getBoundingClientRect();
        if(stickyRect.top < bottom && stickyRect.bottom > top){
          bottom = Math.min(bottom,stickyRect.top);
        }
      }
      var rect = addButton.getBoundingClientRect();
      var visible = addButton.getClientRects().length > 0 &&
        window.getComputedStyle(addButton).visibility !== 'hidden' &&
        rect.bottom > top && rect.top < bottom;
      sticky.hidden = visible;
    }

    function schedule(){
      if(!active || frame !== null) return;
      frame = window.requestAnimationFrame(function(){frame = null;sync();});
    }

    listenForProduct(root,window,'scroll',schedule);
    listenForProduct(root,window,'resize',schedule);
    if(viewport){
      listenForProduct(root,viewport,'scroll',schedule);
      listenForProduct(root,viewport,'resize',schedule);
    }
    var observer = null;
    if(typeof window.ResizeObserver === 'function'){
      observer = new window.ResizeObserver(schedule);
      observer.observe(root);
      if(header) observer.observe(header);
    }
    if(!root._xfunCleanups) root._xfunCleanups = [];
    root._xfunCleanups.push(function(){
      active = false;
      if(frame !== null) window.cancelAnimationFrame(frame);
      if(observer) observer.disconnect();
    });
    sync();
  }

  function initRelatedRail(root){
    var rail=root.querySelector('[data-xfun-related-rail]');
    var dots=Array.prototype.slice.call(root.querySelectorAll('[data-xfun-related-dot]'));
    if(!rail||!dots.length||!window.matchMedia('(max-width: 989px)').matches)return;

    var cards=Array.prototype.slice.call(rail.querySelectorAll('.xfun-luxe-related-card'));
    var raf=null;

    function sync(){
      if(!cards.length)return;
      var cardWidth=cards[0].getBoundingClientRect().width||1;
      var index=Math.max(0,Math.min(dots.length-1,Math.round(rail.scrollLeft/cardWidth)));
      dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index);});
    }

    rail.addEventListener('scroll',function(){
      if(raf)return;
      raf=requestAnimationFrame(function(){raf=null;sync();});
    },{passive:true});

    sync();
  }

  function constrainedConnection(){
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(connection && (connection.saveData || /^(slow-2g|2g|3g)$/.test(connection.effectiveType || '')));
  }

  function createProductPageCache(load,options){
    options = options || {};
    var completed = new Map();
    var pending = new Map();
    var now = options.now || Date.now;
    var ttl = options.ttl || 60000;
    var limit = options.limit || 8;
    var pendingLimit = options.pendingLimit || 4;

    function abortError(){return new DOMException('Aborted','AbortError');}

    function save(key,value){
      completed.delete(key);
      completed.set(key,{value:value,time:now()});
      while(completed.size > limit) completed.delete(completed.keys().next().value);
    }

    function read(key){
      var cached = completed.get(key);
      if(!cached) return null;
      if(now() - cached.time > ttl){completed.delete(key);return null;}
      completed.delete(key);
      completed.set(key,cached);
      return cached.value;
    }

    function request(key,background){
      var entry = pending.get(key);
      if(entry) return entry;
      if(background && pending.size >= 2) return null;
      if(pending.size >= pendingLimit){
        var discarded = Array.from(pending.entries()).find(function(item){return item[1].users === 0;});
        if(discarded){pending.delete(discarded[0]);discarded[1].controller.abort();}
        else return null;
      }
      var controller = new AbortController();
      entry = {controller:controller,users:0,promise:null};
      pending.set(key,entry);
      var timeout = window.setTimeout(function(){controller.abort();},20000);
      entry.promise = Promise.resolve().then(function(){return load(key,controller.signal);}).then(function(value){
        if(controller.signal.aborted) throw abortError();
        if(!value) throw new Error('Product markup');
        save(key,value);
        return value;
      }).finally(function(){
        window.clearTimeout(timeout);
        if(pending.get(key) === entry) pending.delete(key);
      });
      entry.promise.catch(function(){});
      return entry;
    }

    function get(key,signal){
      if(signal && signal.aborted) return Promise.reject(abortError());
      var cached = read(key);
      if(cached) return Promise.resolve(cached);
      var entry = request(key,false);
      if(!entry) return Promise.reject(new Error('Product request queue'));
      entry.users++;
      return new Promise(function(resolve,reject){
        var settled = false;
        function finish(error,value){
          if(settled) return;
          settled = true;
          entry.users--;
          if(signal) signal.removeEventListener('abort',aborted);
          if(error) reject(error);else resolve(value);
        }
        function aborted(){finish(abortError());}
        if(signal) signal.addEventListener('abort',aborted,{once:true});
        entry.promise.then(function(value){finish(null,value);},finish);
        if(signal && signal.aborted) aborted();
      });
    }

    function prefetch(key){
      var cached = read(key);
      if(cached) return Promise.resolve(cached);
      var entry = request(key,true);
      return entry ? entry.promise : Promise.resolve(null);
    }

    return {get:get,prefetch:prefetch,seed:save};
  }

  var initialColorDocument = null;
  var colorNavigationReady = false;

  function initColorNavigation(){
    if(colorNavigationReady || typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function' || typeof window.AbortController !== 'function') return;
    colorNavigationReady = true;
    var stateKey = 'xfunProductColor';
    var renderedUrl = new URL(window.location.href);
    var controller = null;
    var requestId = 0;
    var scrollFrame = null;
    var restoring = false;
    var imageCache = new Map();
    var intentTimers = new Map();
    var pages = createProductPageCache(async function(key,signal){
      var response = await fetch(key,{credentials:'same-origin',headers:{Accept:'text/html','X-Requested-With':'XMLHttpRequest'},signal:signal});
      if(!response.ok) throw new Error('Product request');
      var finalUrl = new URL(response.url || key);
      if(finalUrl.origin !== window.location.origin || !/(?:^|\/)products\/[^/]+\/?$/.test(finalUrl.pathname)) throw new Error('Product destination');
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html,'text/html');
      var root = doc.querySelector('[data-xfun-luxe-product]');
      var node = root && root.querySelector('[data-xfun-variants]');
      var variants = node && JSON.parse(node.textContent || '[]');
      if(!root || !Array.isArray(variants) || !variants.length || !root.querySelector('h1')) throw new Error('Product markup');
      return {html:html,url:finalUrl.href};
    });
    if(initialColorDocument){
      var initialUrl = pageUrl(window.location.href);
      initialUrl.hash = '';
      pages.seed(initialUrl.href,{html:initialColorDocument,url:initialUrl.href});
      initialColorDocument = null;
    }
    var live = document.createElement('span');
    live.className = 'sr-only';
    live.setAttribute('role','status');
    live.setAttribute('aria-live','polite');
    live.setAttribute('aria-atomic','true');
    document.body.appendChild(live);

    function productRoot(){
      return document.querySelector('[data-xfun-luxe-product]');
    }

    function pageUrl(value){
      var url = new URL(value,window.location.href);
      if(/^#XfunProductColor-\d+$/.test(url.hash)) url.hash = '';
      return url;
    }

    function samePage(a,b){
      return a.origin === b.origin && a.pathname === b.pathname && a.search === b.search;
    }

    function mergeState(value){
      var state = window.history.state;
      var next = state && typeof state === 'object' ? Object.assign({},state) : {};
      next[stateKey] = value;
      return next;
    }

    function position(){
      return {x:window.scrollX,y:window.scrollY};
    }

    function remember(){
      if(restoring || !samePage(pageUrl(window.location.href),pageUrl(renderedUrl.href))) return;
      var point = position();
      window.history.replaceState(mergeState({url:renderedUrl.href,x:point.x,y:point.y}),'',window.location.href);
    }

    function setBusy(root,value){
      if(!root) return;
      if(value){
        root.dataset.xfunColorLoading = 'true';
        root.setAttribute('aria-busy','true');
        root.querySelectorAll('[data-xfun-add],[data-xfun-sticky-add]').forEach(function(button){
          button.disabled = true;
          button.setAttribute('aria-disabled','true');
        });
      }else{
        delete root.dataset.xfunColorLoading;
        root.removeAttribute('aria-busy');
        if(root._xfunRefreshPurchase) root._xfunRefreshPurchase();
      }
      root.dispatchEvent(new CustomEvent('xfun:product:color-loading',{bubbles:true,detail:{loading:value}}));
    }

    function cancel(){
      requestId++;
      if(controller) controller.abort();
      controller = null;
      restoring = false;
      setBusy(productRoot(),false);
    }

    function isProductData(node){
      if(!node || typeof node !== 'object') return false;
      if(Array.isArray(node)) return node.some(isProductData);
      var type = node['@type'];
      if(type === 'Product' || type === 'ProductGroup' || Array.isArray(type) && (type.indexOf('Product') !== -1 || type.indexOf('ProductGroup') !== -1)) return true;
      return node['@graph'] ? isProductData(node['@graph']) : false;
    }

    function productDataScripts(doc){
      return Array.prototype.filter.call(doc.querySelectorAll('script[type="application/ld+json"]'),function(script){
        try{return isProductData(JSON.parse(script.textContent));}catch(error){return false;}
      });
    }

    function updateHead(doc,newRoot){
      var selector = 'meta[name="description"],meta[property^="og:"],meta[name^="twitter:"],link[rel="canonical"]';
      document.head.querySelectorAll(selector).forEach(function(node){node.remove();});
      doc.head.querySelectorAll(selector).forEach(function(node){document.head.appendChild(document.importNode(node,true));});
      document.title = doc.title;
      productDataScripts(document).forEach(function(node){node.remove();});
      productDataScripts(doc).forEach(function(node){document.head.appendChild(document.importNode(node,true));});
      productDataScripts(newRoot).forEach(function(node){node.remove();});
    }

    function imageTask(root,priority){
      var source = root.querySelector('[data-xfun-gallery-slide] img');
      if(!source) return null;
      var src = source.getAttribute('src') || source.currentSrc;
      if(!src) return null;
      var sizes = source.getAttribute('sizes') || '';
      var srcset = source.getAttribute('srcset') || '';
      var key = src + '\n' + srcset + '\n' + sizes;
      var task = imageCache.get(key);
      if(task){
        imageCache.delete(key);
        imageCache.set(key,task);
        if(priority === 'high') task.image.fetchPriority = 'high';
        return task;
      }
      var image = new Image();
      image.decoding = 'async';
      image.fetchPriority = priority || 'low';
      task = {image:image,promise:null};
      task.promise = new Promise(function(resolve){
        var settled = false;
        function done(){
          if(settled) return;
          settled = true;
          image.onload = null;
          image.onerror = null;
          resolve();
        }
        image.onload = done;
        image.onerror = done;
        if(sizes) image.sizes = sizes;
        if(srcset) image.srcset = srcset;
        image.src = src;
        if(image.complete) done();
      });
      imageCache.set(key,task);
      while(imageCache.size > 12) imageCache.delete(imageCache.keys().next().value);
      return task;
    }

    function preloadImage(root,signal){
      if(signal.aborted) return Promise.reject(new DOMException('Aborted','AbortError'));
      var task = imageTask(root,'high');
      if(!task || task.image.complete) return Promise.resolve();
      return new Promise(function(resolve,reject){
        var settled = false;
        var timeout;
        function done(error){
          if(settled) return;
          settled = true;
          window.clearTimeout(timeout);
          signal.removeEventListener('abort',aborted);
          if(error) reject(error);else resolve();
        }
        function aborted(){done(new DOMException('Aborted','AbortError'));}
        signal.addEventListener('abort',aborted,{once:true});
        timeout = window.setTimeout(function(){done();},700);
        task.promise.then(function(){done();});
        if(signal.aborted) aborted();
      });
    }

    function resetProductRoot(root){
      root.removeAttribute('data-xfun-initialized');
      root.removeAttribute('data-xfun-cart-pending');
      root.removeAttribute('data-xfun-color-loading');
      root.removeAttribute('aria-busy');
      root.setAttribute('data-selected-variant','');
      root.querySelectorAll('[data-xfun-option-value]').forEach(function(button){
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed','false');
      });
      root.querySelectorAll('[data-xfun-size-select]').forEach(function(select){select.value = '';});
      var nativeSelect = root.querySelector('[data-xfun-native-variant-select]');
      if(nativeSelect){
        nativeSelect.querySelectorAll('option[selected]').forEach(function(option){option.removeAttribute('selected');});
        nativeSelect.value = '';
      }
    }

    function colorIntent(event){
      if(constrainedConnection()) return;
      var link = event.target instanceof Element ? event.target.closest('a.xfr-product-color__swatch[data-xfun-color-product]') : null;
      if(!link || link.getAttribute('aria-current') === 'page' || !link.closest('[data-xfun-luxe-product]')) return;
      var destination = new URL(link.href,window.location.href);
      if(destination.origin !== window.location.origin || !/(?:^|\/)products\/[^/]+\/?$/.test(destination.pathname)) return;
      var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if(preview && !destination.searchParams.has('preview_theme_id')) destination.searchParams.set('preview_theme_id',preview);
      destination.hash = '';
      destination.searchParams.delete('variant');
      if(intentTimers.has(destination.href)) return;
      var timer = window.setTimeout(function(){
        intentTimers.delete(destination.href);
        pages.prefetch(destination.href).then(function(page){
          if(!page || constrainedConnection()) return;
          var doc = new DOMParser().parseFromString(page.html,'text/html');
          var root = doc.querySelector('[data-xfun-luxe-product]');
          if(root) imageTask(root,'low');
        }).catch(function(){});
      },event.type === 'pointerover' ? 60 : 0);
      intentTimers.set(destination.href,timer);
    }

    document.addEventListener('pointerover',colorIntent,{passive:true});
    document.addEventListener('focusin',colorIntent);
    document.addEventListener('touchstart',colorIntent,{passive:true});

    function waitForPurchase(root,signal){
      if(signal.aborted) return Promise.reject(new DOMException('Aborted','AbortError'));
      if(root.dataset.xfunCartPending !== 'true') return Promise.resolve();
      return new Promise(function(resolve,reject){
        var settled = false;
        function finish(error){
          if(settled) return;
          settled = true;
          root.removeEventListener('xfun:product:pending',changed);
          signal.removeEventListener('abort',aborted);
          if(error) reject(error);else resolve();
        }
        function changed(event){if(event.detail && event.detail.pending === false) finish();}
        function aborted(){finish(new DOMException('Aborted','AbortError'));}
        root.addEventListener('xfun:product:pending',changed);
        signal.addEventListener('abort',aborted,{once:true});
        if(signal.aborted) aborted();
      });
    }

    function visualAnchor(root){
      var gallery = root.querySelector('[data-xfun-gallery-viewport]');
      var row = root.querySelector('.xfr-product-color');
      var header = document.querySelector('[data-xfun-header]');
      var headerBottom = header ? Math.max(0,header.getBoundingClientRect().bottom) : 0;
      var galleryRect = gallery && gallery.getBoundingClientRect();
      var rowRect = row && row.getBoundingClientRect();
      var bothVisible = galleryRect && rowRect && galleryRect.bottom > headerBottom && galleryRect.top < window.innerHeight && rowRect.bottom > headerBottom && rowRect.top < window.innerHeight;
      if(bothVisible) return {selector:'[data-xfun-gallery-viewport]',top:galleryRect.top};
      if(rowRect) return {selector:'.xfr-product-color',top:rowRect.top};
      return null;
    }

    function restoreView(root,anchor,point,restoreSaved){
      var html = document.documentElement;
      var previousBehavior = html.style.scrollBehavior;
      var previousAnchor = html.style.overflowAnchor;
      html.style.scrollBehavior = 'auto';
      html.style.overflowAnchor = 'none';
      var target = root.querySelector(anchor && anchor.selector || '.xfr-product-color');
      var y = point.y;
      if(!restoreSaved && anchor && target) y = window.scrollY + target.getBoundingClientRect().top - anchor.top;
      window.scrollTo({left:point.x,top:Math.max(0,y),behavior:'auto'});
      window.requestAnimationFrame(function(){
        if(root.isConnected){
          target = root.querySelector(anchor && anchor.selector || '.xfr-product-color');
          y = restoreSaved ? point.y : anchor && target ? window.scrollY + target.getBoundingClientRect().top - anchor.top : window.scrollY;
          window.scrollTo({left:point.x,top:Math.max(0,y),behavior:'auto'});
        }
        window.requestAnimationFrame(function(){
          html.style.scrollBehavior = previousBehavior;
          html.style.overflowAnchor = previousAnchor;
        });
      });
    }

    async function navigate(destination,options){
      options = options || {};
      if(controller) controller.abort();
      var active = new AbortController();
      controller = active;
      var id = ++requestId;
      var oldRoot = productRoot();
      if(!oldRoot) return;
      var fallback = options.fallback || destination.href;
      if(!options.restore) remember();
      restoring = !!options.restore;
      setBusy(oldRoot,true);
      var timeout = window.setTimeout(function(){active.abort();},20000);
      try{
        var page = await pages.get(destination.href,active.signal);
        var doc = new DOMParser().parseFromString(page.html,'text/html');
        var parsedRoot = doc.querySelector('[data-xfun-luxe-product]');
        var variantsNode = parsedRoot && parsedRoot.querySelector('[data-xfun-variants]');
        var variants = variantsNode && JSON.parse(variantsNode.textContent || '[]');
        if(!parsedRoot || !Array.isArray(variants) || !variants.length || !parsedRoot.querySelector('h1')) throw new Error('Product markup');
        resetProductRoot(parsedRoot);
        await preloadImage(parsedRoot,active.signal);
        await waitForPurchase(oldRoot,active.signal);
        if(id !== requestId || active.signal.aborted || !oldRoot.isConnected) return;
        var anchor = visualAnchor(oldRoot);
        var point = options.restore ? options.point : position();
        var newRoot = document.importNode(parsedRoot,true);
        if(!options.restore) remember();
        destination.hash = '';
        if(options.restore){
          window.history.replaceState(mergeState({url:destination.href,x:point.x,y:point.y}),'',destination.href);
        }else{
          window.history.pushState(mergeState({url:destination.href,x:point.x,y:point.y}),'',destination.href);
        }
        renderedUrl = new URL(destination.href);
        updateHead(doc,newRoot);
        cleanupProduct(oldRoot);
        oldRoot.replaceWith(newRoot);
        boot();
        restoreView(newRoot,anchor,point,!!options.restore);
        if(options.focus){
          var current = newRoot.querySelector('.xfr-product-color__swatch[aria-current="page"]');
          if(current) current.focus({preventScroll:true});
        }
        live.textContent = newRoot.querySelector('h1').textContent.trim() + ' — ' + (newRoot.querySelector('.xfr-product-color__label') || newRoot.querySelector('h1')).textContent.trim();
        restoring = false;
        remember();
        document.dispatchEvent(new CustomEvent('xfun:product:loaded',{detail:{root:newRoot,url:destination.href}}));
      }catch(error){
        if(id !== requestId) return;
        if(active.signal.aborted && controller !== active) return;
        window.location.assign(fallback);
      }finally{
        window.clearTimeout(timeout);
        if(id === requestId){
          controller = null;
          restoring = false;
          setBusy(productRoot(),false);
        }
      }
    }

    document.addEventListener('click',function(event){
      if(event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target instanceof Element ? event.target.closest('a.xfr-product-color__swatch[data-xfun-color-product]') : null;
      if(!link || link.hasAttribute('download') || link.target && link.target !== '_self') return;
      var root = link.closest('[data-xfun-luxe-product]');
      var destination = new URL(link.href,window.location.href);
      if(!root || destination.origin !== window.location.origin || !/(?:^|\/)products\/[^/]+\/?$/.test(destination.pathname)) return;
      var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if(preview && !destination.searchParams.has('preview_theme_id')) destination.searchParams.set('preview_theme_id',preview);
      var fallback = destination.href;
      destination.hash = '';
      destination.searchParams.delete('variant');
      event.preventDefault();
      if(root.dataset.xfunCartPending === 'true') return;
      if(link.getAttribute('aria-current') === 'page'){
        cancel();
        return;
      }
      navigate(destination,{fallback:fallback,focus:event.detail === 0});
    });

    window.addEventListener('popstate',function(event){
      var saved = event.state && event.state[stateKey];
      if(!saved || typeof saved.url !== 'string'){
        cancel();
        window.location.reload();
        return;
      }
      var destination = pageUrl(saved.url);
      if(destination.origin !== window.location.origin || !samePage(destination,pageUrl(window.location.href))){
        cancel();
        window.location.reload();
        return;
      }
      var point = {x:Number.isFinite(saved.x) ? saved.x : 0,y:Number.isFinite(saved.y) ? saved.y : 0};
      if(samePage(destination,pageUrl(renderedUrl.href))){
        cancel();
        restoreView(productRoot(),null,point,true);
        return;
      }
      navigate(destination,{restore:true,point:point,fallback:window.location.href});
    });

    window.addEventListener('scroll',function(){
      if(scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(function(){scrollFrame = null;remember();});
    },{passive:true});
    window.addEventListener('pagehide',function(){remember();if('scrollRestoration' in history) history.scrollRestoration = 'auto';});
    window.addEventListener('pageshow',function(){if('scrollRestoration' in history) history.scrollRestoration = 'manual';});
    if('scrollRestoration' in history) history.scrollRestoration = 'manual';
    remember();
  }

  function boot(){
    if(!colorNavigationReady && !initialColorDocument && document.querySelector('[data-xfun-luxe-product]')){
      initialColorDocument = '<!doctype html>' + document.documentElement.outerHTML;
    }
    document.querySelectorAll('[data-xfun-luxe-product]').forEach(function(root){
      if(root.dataset.xfunInitialized === 'true') return;
      root.dataset.xfunInitialized = 'true';
      initGallery(root);
      initSizeModal(root);
      initVariants(root);
      initSticky(root);
      initRelatedRail(root);
    });
    initColorNavigation();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }

  document.addEventListener('shopify:section:load',boot);
})();






